import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Crown, TrendingUp, CheckCircle2 } from "lucide-react";

export default function RecapBanner({ weekNumber }) {
  const [recap, setRecap] = useState(null);

  useEffect(() => {
    if (!weekNumber) return;
    setRecap(null);
    api.get(`/recap/${weekNumber}`).then((res) => setRecap(res.data)).catch(() => setRecap(null));
  }, [weekNumber]);

  if (!recap || !recap.has_results || !recap.winner) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6" data-testid="recap-banner">
      <div className="bg-[#141414] border border-[#EAB308]/40 p-5 flex items-center gap-4 relative overflow-hidden">
        <div className="absolute -right-4 -top-4 opacity-10">
          <Crown className="w-24 h-24 text-[#EAB308]" />
        </div>
        <div className="w-12 h-12 bg-[#EAB308]/15 border border-[#EAB308]/40 flex items-center justify-center shrink-0">
          <Crown className="w-6 h-6 text-[#EAB308]" />
        </div>
        <div className="relative">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#EAB308] flex items-center gap-1.5">
            Week {recap.week_number} Winner
            {recap.finalized ? (
              <span className="inline-flex items-center gap-1 text-[#22C55E] normal-case tracking-normal">
                <CheckCircle2 className="w-3 h-3" /> Final
              </span>
            ) : (
              <span className="text-white/40 normal-case tracking-normal">· {recap.decided}/{recap.total_games} games in</span>
            )}
          </div>
          <div className="font-['Bebas_Neue'] text-3xl tracking-wide leading-none mt-1">{recap.winner.username}</div>
          <div className="text-sm text-white/60">{recap.winner.points} pts this week</div>
        </div>
      </div>

      {recap.biggest_mover ? (
        <div className="bg-[#141414] border border-[#22C55E]/40 p-5 flex items-center gap-4 relative overflow-hidden" data-testid="recap-mover">
          <div className="absolute -right-4 -top-4 opacity-10">
            <TrendingUp className="w-24 h-24 text-[#22C55E]" />
          </div>
          <div className="w-12 h-12 bg-[#22C55E]/15 border border-[#22C55E]/40 flex items-center justify-center shrink-0">
            <TrendingUp className="w-6 h-6 text-[#22C55E]" />
          </div>
          <div className="relative">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#22C55E]">Biggest Mover</div>
            <div className="font-['Bebas_Neue'] text-3xl tracking-wide leading-none mt-1">{recap.biggest_mover.username}</div>
            <div className="text-sm text-white/60">
              Jumped {recap.biggest_mover.delta} spot{recap.biggest_mover.delta > 1 ? "s" : ""} · #{recap.biggest_mover.from_rank} → #{recap.biggest_mover.to_rank}
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-[#141414] border border-white/10 p-5 flex items-center gap-4">
          <div className="w-12 h-12 bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
            <TrendingUp className="w-6 h-6 text-white/40" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40">Biggest Mover</div>
            <div className="text-sm text-white/50 mt-1">Standings shake up once more weeks are in the books.</div>
          </div>
        </div>
      )}
    </div>
  );
}
